import React, { useEffect } from 'react';
import '../styles/nav.css';
import { useState } from 'react';
import logo from "../images/logo1.jpg"
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

function Navbar() {
    const [toggle, setToggle] = useState(false);

    useEffect(() => {
        if (!toggle) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, [toggle]);

    const close = () => setToggle(false);

    const handleLogoClick = () => {
        close();
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    return (
        <>
        <header className="site-header">
        <nav className="nav-holder" aria-label="Primary">
          <div className="nav-logo">
            <Link to="/" onClick={handleLogoClick}>
              <img src={logo} alt="Wedding Stories logo" />
            </Link>
          </div>
          <div className="nav-options">
              <Link to="/gallery"><span className="nav-ind-options">Gallery</span></Link>
              <Link to="/#packages" onClick={close}><span className="nav-ind-options">Packages</span></Link>
              <Link to="/testimonials" onClick={close}><span className="nav-ind-options">Review</span></Link>
              <Link to="/team" onClick={close}><span className="nav-ind-options">Team</span></Link>
              <Link to="/#about" onClick={close}><span className="nav-ind-options">About</span></Link>
              <Link to="/#contact" onClick={close}><span className="nav-ind-options">Contact Us</span></Link>
              <Link to="/privacy-policy" onClick={close}><span className="nav-ind-options">Privacy Policy</span></Link>
              <Link to="/terms-and-conditions" onClick={close}><span className="nav-ind-options">Terms & Conditions</span></Link>
          </div>
          <button
            type="button"
            className="toggle-logo"
            onClick={() => setToggle(!toggle)}
            aria-expanded={toggle}
            aria-controls="mobile-nav"
            aria-label={toggle ? 'Close menu' : 'Open menu'}
          >
            <FontAwesomeIcon icon={toggle ? faXmark : faBars} />
          </button>
        </nav>
        </header>
        {toggle && (
          <button type="button" className="nav-backdrop" aria-label="Close menu" onClick={close} />
        )}
        <nav id="mobile-nav" className={toggle ? 'nav-dropdown is-open' : 'nav-dropdown'} aria-hidden={!toggle}>
                <Link to="/gallery" onClick={close}><span className="nav-ind-options">Gallery</span></Link>
                <Link to="/#packages" onClick={close}><span className="nav-ind-options">Packages</span></Link>
                <Link to="/testimonials" onClick={close}><span className="nav-ind-options">Reviews</span></Link>
                <Link to="/team" onClick={close}><span className="nav-ind-options">Team</span></Link>
                <Link to="/#about" onClick={close}><span className="nav-ind-options">About</span></Link>
                <Link to="/#contact" onClick={close}><span className="nav-ind-options">Contact Us</span></Link>
                <Link to="/privacy-policy" onClick={close}><span className="nav-ind-options">Privacy Policy</span></Link>
                <Link to="/terms-and-conditions" onClick={close}><span className="nav-ind-options">Terms & Conditions</span></Link>
        </nav>
    </>
  )
}

export default Navbar;
